import { render, staticRenderFns } from "./Main_Management.vue?vue&type=template&id=7a5a5b0a&scoped=true"
import script from "./Main_Management.vue?vue&type=script&lang=js"
export * from "./Main_Management.vue?vue&type=script&lang=js"
import style0 from "./Main_Management.vue?vue&type=style&index=0&id=7a5a5b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5a5b0a",
  null
  
)

export default component.exports